import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@applift/factor'
import { ExternalLink, InfoCircle } from '@applift/icons'
import { validationUtils } from 'iqm-framework'
import { TestPixel } from '../../models/Pixel'

export interface TestPixelDialogProps {
  onClose: () => void
  testPixel: TestPixel
}

export const PixelTestDialog = (props: TestPixelDialogProps) => {
  const { onClose, testPixel } = props
  const { action, name } = testPixel

  const [integrationURL, setIntegrationURL] = React.useState('')

  const handleTestClick = () => {
    const regex = /^https{0,1}:\/\//
    const withProtocol = !regex.test(integrationURL)
      ? `http://${integrationURL}`
      : integrationURL
    const anchor = document.createElement('a')
    anchor.style.display = 'none'
    anchor.setAttribute('href', withProtocol)
    anchor.setAttribute('target', '_blank')
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    onClose()
  }

  const isValidUrl = validationUtils.isValidURL(integrationURL)

  return (
    <Dialog maxWidth="sm" open={true}>
      <DialogTitle onClose={onClose}>{`${
        action === 'test' ? 'Test' : 'Retest'
      } Pixel Conversion`}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography>
            <>
              Enter the integration page url to test the pixel{' '}
              <Typography sx={{ textWeight: 'demi' }}>{name}</Typography>
              {' & '}
              perform the conversion action in the newly opened tab.{' '}
            </>
          </Typography>
          <TextField
            label="Integration page URL"
            sx={{ mt: 16, mb: 12 }}
            variant="outlinedDash"
            placeholder="Enter the integration page URL"
            onChange={e =>
              e.target.value.trim() || e.target.value === ''
                ? setIntegrationURL(e.target.value)
                : null
            }
            value={integrationURL}
            error={!isValidUrl}
            helperText={!isValidUrl ? 'Please enter a valid URL' : undefined}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 8 }}>
            <InfoCircle
              fontSize={24}
              sx={{ mr: 4, textColor: 'neutral-400' }}
            />
            <Typography variant="label" sx={{ textColor: 'neutral-500' }}>
              {action === 'test'
                ? `It might take up to 2 hours for the pixel to change its status to
              active after a successful conversion is performed.`
                : `It might take up to 2 hours for the pixel to reflect the changes.`}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={!integrationURL || !isValidUrl}
          onClick={handleTestClick}
        >
          <ExternalLink fontSize={24} sx={{ mr: 4 }} />
          {`${action === 'test' ? 'Test' : 'Retest'} Pixel`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
